import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { Sprig } from "./Botanical";

export const BigIdea = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

    return (
        <section
            ref={ref}
            className="grain relative overflow-hidden bg-plum py-20 text-center sm:py-28"
            data-testid="big-idea-section"
        >
            <div
                aria-hidden
                className="pointer-events-none absolute left-1/2 top-1/2 h-[36rem] w-[36rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-burgundy/40 blur-3xl"
            />
            <Sprig className="pointer-events-none absolute left-6 top-8 w-16 rotate-[15deg] text-gold/20 sm:left-14" />
            <Sprig className="pointer-events-none absolute bottom-8 right-6 w-16 rotate-[195deg] text-gold/20 sm:right-14" />

            <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8">
                <Reveal>
                    <h2 className="font-serif text-2xl font-medium uppercase leading-snug tracking-[0.04em] text-cream sm:text-3xl lg:text-5xl">
                        The Problem May Not Be Your Partner.
                    </h2>
                </Reveal>
                <motion.p
                    style={{ y }}
                    className="mt-5 font-serif text-3xl italic leading-tight text-gold sm:text-4xl lg:text-6xl"
                    data-testid="big-idea-highlight"
                >
                    It may be the pattern between you.
                </motion.p>
                <Reveal delay={0.1}>
                    <p className="mx-auto mt-9 max-w-xl text-base leading-relaxed text-cream/80 sm:text-lg">
                        When the same reactions happen again and again, couples can slowly create distance without
                        even realising it.
                    </p>
                    <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-cream/80 sm:text-lg">
                        The first step isn&rsquo;t blame.{" "}
                        <strong className="font-semibold text-gold">It&rsquo;s awareness.</strong>
                    </p>
                </Reveal>
            </div>
        </section>
    );
};

export default BigIdea;
